import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

export enum providers {
    HERE = 'here',
    TOMTOM = 'tomtom',
    GARMIN = 'garmin'
}

export interface MapPackage {
    translationKey: string,
    link: string,
    sizeGB: number,
    updatedAt: string,
    provider: providers,
    isMapComplete: boolean,
    isSizeSensitive: boolean
}

export interface MapPackagesData {
    MIB: string,
    manuals: { [id: string]: string },
    downloads: MapPackage[]
}

export class MapPackagesService {

    private readonly resourceHostId: string;

    constructor(private readonly authService: IAuthServiceV2, stage: string) {
        this.resourceHostId = `cwat-vw-navigation-map-update-service-${stage}`;
    };

    public async getMapPackages(vin: string): Promise<MapPackagesData | null> {
        const url = `packages/${vin}`;

        try {
            const response = await this.authService.get(this.resourceHostId, url);
            if (response.ok) {
                return await response.json();
            }
        } catch (error) {
            console.log(error);
        }

        return null;
    }
}